import * as actions from 'store/destination/destinationActions';
import * as client from 'lib/clients/fetchMerchandise';
import { createAsyncLogic } from 'lib/logic';

export const fetchMerchandiseLogic = createAsyncLogic({
  type: actions.fetchMerchandise,
  latest: true,
  async process({ action }, dispatch) {
    const { payload } = action;
    const destination = await client.fetchMerchandise(payload);
    dispatch(actions.setMerchandise(destination));
  },
  onError({ parsedError }, dispatch) {
    dispatch(actions.fetchMerchandiseFailure(parsedError));
  },
});
